import Vue from 'vue'
import {Button, Row, Col, Form, Input, AutoComplete, Icon, Tabs, Checkbox, Table, Modal, message} from 'ant-design-vue'

const {Item} = Form
// Vue.use(Input)
import CommonFramework from "@/shared/components/commonFramework/index";
import poptitle from '@components/title/index.vue'
import mixin from "@utils/form";
import sendmobile from '@components/sendsms/sendmobile/index'
import sendemail from '@components/sendsms/sendemail/index'
import CONSTANT from "../../../shared/utils/constant";
import {mapState, mapActions} from 'vuex'
import cookie from 'js-cookie'
import {Base64} from 'js-base64'
import {util} from '@utils';

// const { mapState, mapActions } = createNamespacedHelpers('pages/empManage/add')
export default {
  components: {
    Input, Button, Icon, AutoComplete, Form, Item, Row, Col, Tabs, Checkbox, Table,
    CommonFramework, poptitle, sendmobile, sendemail
  },
  mixins: [mixin],
  data() {
    return {
      rowKey: 'roleId',
      columns: [{
        title: '角色名称',
        dataIndex: 'roleName',
        align: 'center',
      }
        // ,{
        //     title: '角色描述',
        //     dataIndex: 'desc',
        //     align: 'center',
        // }
      ],
      form: {
        name: {
          value: '',
          validateStatus: '',
          help: '限1-12位字符，中文或字母开头，支持中文、数字、字母、-的组合'
        },

        newPassword: {
          value: '',
          validateStatus: '',
          help: this.$store.state.securityConfig.pwdValidMsg
        },
        confirmNewPassword: {
          value: '',
          validateStatus: '',
          help: this.$store.state.securityConfig.pwdValidMsg
        },
        newPhone: {
          value: '',
          validateStatus: '',
          help: '请输入账号绑定手机号'
        },
        newEmail: {
          value: '',
          validateStatus: '',
          help: '请输入账号绑定邮箱'
        },
        code: {
          value: '',
          validateStatus: '',
          help: ''
        },
        // codeEmail: {
        //     value: '',
        //     validateStatus: '',
        //     help: ''
        // },
      },
      isSendCode: false,
      isSendECode: false,
      isAdd: true,
      selectedRowKeys: []
    }
  },
  computed: {
    ...mapState('pages/empManage', ['rolesList']),
    rowSelection() {
      const {selectedRowKeys} = this;
      return {
        selectedRowKeys,
        onChange: this.onChange,
      }
    }
  },
  async beforeMount() {
    let aid = cookie.get('id')
    let type = this.$route.params.type;
    let id = this.$route.query.id;
    this.isAdd = type === 'edit' ? false : true;
    await this.listAllRoles({params: {aid}})
    if (id) {
      //调接口
      let res = await this.getEmpDetail({param: JSON.stringify({aid: id})})
      if (res.code * 1 === 1) {
        this.form.name.value = res.data ? res.data.nickName : '';
        this.form.newPhone.value = res.data ? res.data.phone : '';
        let strArr = res.data ? (res.data.roles ? res.data.roles.split(',') : []) : []
        this.selectedRowKeys = strArr.map(item => {
          return item
        })
        this.$nextTick(() => {
          this.isDisabled = false;
        })
      } else {
        this.$message.error(res.msg)
      }
    }
  },
  mounted() {
    util.$tracker(157, '288922', 10000);
  },
  watch: {},
  methods: {
    ...mapActions('pages/empManage/add', ['addEmpAccount', 'resetEmpPwd', 'updateEmpInfo', 'getEmpDetail']),
    ...mapActions('pages/empManage', ['listAllRoles']),
    onChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
    },
    routeJump() {
      // let that = this;
      Modal.confirm({
        title: '确定重置密码?',
        content: '密码重置为初始密码hzw365',
        onOk: async (close) => {
          let res = await this.resetEmpPwd({param: {loginName: this.form.newPhone.value}})
          if (res.code * 1 === 1) {
            close()
            this.$message.success('重置成功')
          } else {
            this.$message.error(res.msg)
          }
        },
        onCancel() {
        },
      });
    },
    async getNewCode() {
      // this.validateFields(['newPhone'] 状态校验
      if (await this.validateFields(['newPhone'])) {
        this.isSendCode = true
      } else {
        this.isSendCode = false
      }
    },
    checkCode() {
      // 校验验证码一栏是是否正确
      this.validateFields(['code'])
    },
    async getNewECode() {
      // this.validateFields(['newPhone'] 状态校验
      if (await this.validateFields(['newEmail'])) {
        this.isSendECode = true
      } else {
        this.isSendECode = false
      }
    },
    checkECode() {
      // 校验验证码一栏是是否正确
      this.validateFields(['codeEmail'])
    },
    async save() {
      let fatherId = cookie.get('id');
      let roleCodes = [];
      this.selectedRowKeys.forEach(val => {
        this.rolesList.forEach(item => {
          if (val === item.roleId) {
            roleCodes.push(item.roleCode);
          }
        })

      })
      /**
       * 增加选择非空判断
       * @date 2019/11/26 20:35
       * @author 施宜
       *
       */
      if (roleCodes.length === 0) {
        message.error(`需选择一个分配角色！`)
      } else {
        let param = {
          fatherId,
          phone: this.form.newPhone.value,
          phoneVcode: Base64.encode(this.form.code.value),
          phoneIdentity: Base64.encode(this.form.newPhone.value),
          phoneServiceCode: Base64.encode(CONSTANT.APPSERVICECODE_REG),
          nickName: this.form.name.value,
          email: this.form.newEmail.value,
          // emailCode:this.form.codeEmail.value,
          password: this.form.newPassword.value,
          confirmPwd: this.form.confirmNewPassword.value,
          rids: this.selectedRowKeys,
          roleCodes: roleCodes
        }
        let type = this.$route.params.type;
        if (type === 'add') {
          if (await this.validateFields()) {
            let res = await this.addEmpAccount({param: JSON.stringify(param)})
            if (res.code * 1 === 1) {
              this.callback();
            } else {
              this.$message.error(res.msg)
            }
          }
        } else if (type === 'edit') {
          let aid = this.$route.query.id;
          param = {
            rids: this.selectedRowKeys.join(','),
            loginName: this.$route.params.userName,
            aid,
            roleCodes: roleCodes.join(',')
          }
          let res = await this.updateEmpInfo({param: JSON.stringify(param)})
          if (res.code * 1 === 1) {
            this.callback();
          } else {
            this.$message.error(res.msg)
          }
        }
      }
    },
    callback() {
      this.$message.success('保存成功').then(() => {
        this.$router.go(-1)
      });
    },

  },
}
